import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41c90080"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container-lg container-fluid w-100 pt-3 mt-5 d-flex justify-content-end",
  id: "scrollArea"
}
const _hoisted_2 = { class: "mt-3 mb-2 text-primary w-100 justify-content-start" }
const _hoisted_3 = { class: "d-none" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Innovation Proposal", -1))
const _hoisted_5 = { class: "w-lg-25 justify-content-end" }
const _hoisted_6 = { class: "p-input-icon-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_8 = { class: "call_for_innovation pb-5 container" }
const _hoisted_9 = { class: "container pb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-center text-primary my-3 fw-bold" }, " Recently Submitted Innovation Proposals ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center text-primary w-100 mb-3 d-md-block" }, " This is a list of the most recent published innovations submitted by different innovators to address the health needs highlighted by the Botswana Ministry of Health. Please select any of the innovation proposals from the list below to initiate the partnership process ", -1))
const _hoisted_12 = { class: "px-lg-3" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "d-flex align-items-center justify-content-center no_need" }
const _hoisted_17 = {
  key: 1,
  class: "data_container"
}
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = {
  key: 1,
  class: "message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ScrollArea = _resolveComponent("ScrollArea")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_List = _resolveComponent("List")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h6", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/priority-needs" }, {
            default: _withCtx(() => [
              _createTextVNode("Innovations")
            ]),
            _: 1
          }),
          _createTextVNode(" / "),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createVNode(_component_InputText, {
            type: "text",
            modelValue: _ctx.searchParams,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParams) = $event)),
            placeholder: "Search"
          }, null, 8, ["modelValue"]), [
            [_directive_tooltip, 'Enter at least 3 characters to search']
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("section", _hoisted_9, [
        _hoisted_10,
        _hoisted_11,
        _createVNode(_component_ScrollArea, { onProgramId: _ctx.programArea }, null, 8, ["onProgramId"])
      ]),
      _createElementVNode("section", _hoisted_12, [
        (_ctx.loading === true)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                return _createVNode(_component_Skeleton, {
                  width: "100%",
                  height: "7rem",
                  class: "mb-3",
                  key: i
                })
              }), 64))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_ctx.publishedData.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h4", null, [
                        _createTextVNode(" No Innovation Found for "),
                        _createElementVNode("u", null, _toDisplayString(_ctx.tagTitle), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.publishedData.length > 0)
                ? (_openBlock(), _createElementBlock("main", _hoisted_17, [
                    (_ctx.Message === '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publishedData, (item, i) => {
                            return (_openBlock(), _createBlock(_component_List, {
                              key: i,
                              body: item,
                              card: _ctx.cardListStyle,
                              route: `/partners/partner-on-proposal/${item.id}?id=${item.id}`
                            }, null, 8, ["body", "card", "route"]))
                          }), 128))
                        ]))
                      : (_ctx.Message !== '')
                        ? (_openBlock(), _createElementBlock("h5", _hoisted_19, _toDisplayString(_ctx.Message), 1))
                        : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])),
        (_ctx.publishedData.length > 0 && _ctx.Message === '' && _ctx.byTag === false)
          ? (_openBlock(), _createBlock(_component_Paginator, {
              key: 2,
              rows: _ctx.publishedDataPagination.size,
              totalRecords: _ctx.publishedDataPagination.total_records,
              onPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPage($event))),
              class: "p-pagination-sm"
            }, null, 8, ["rows", "totalRecords"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}